import React, { Fragment } from 'react';
import LicenceType from './licenceType';
import styled from 'styled-components';
import I10n from '../../features/i10n';

const Container = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.span`
  font-size: 22px;
  margin-top: 0px;
  font-weight: 400;
`;

class LicenceGroup extends React.Component {

    render() {
      const {
        licenceGroup,
        isSaving,
        onAddSoftwareLicencesRequested,
        softwareLicences,
        configurationSaver,
        removeSoftwareLicence,
        setSoftwareLicenceQuantity,
        licenseLevel,
        licenseModel
      } = this.props;


      // Show the license type if:
      const visibleLicenceTypes = licenceGroup.licenceTypes.filter((licenceType) => {

        // Any license was was added to it (from another country or newly unscopped reference).
        if (softwareLicences
          .filter((licence) => licence.licenceGroup === licenceGroup.key && licence.licenceCategory === licenceType.key).length > 0) {
            return true;
        }

        // Can select any license
        return [...licenceType.scopedReferences].length > 0;
      });

      if (visibleLicenceTypes.length === 0) {
        return (<></>);
      }

      return (
        <Container>
          <Title>{I10n.getOrDefault(`bom.licence.licencegroup.name.${licenceGroup.key}`, licenceGroup.name)}</Title>
          {visibleLicenceTypes.map((licenceType, idx) => {
            return (
              <Fragment key={idx}>
              <LicenceType
                  licenseModel={licenseModel}
                  licenceType={licenceType}
                  licenceGroup={licenceGroup}
                  isSaving={isSaving}
                  onAddSoftwareLicencesRequested={onAddSoftwareLicencesRequested}
                  softwareLicences={softwareLicences}
                  configurationSaver={configurationSaver}
                  removeSoftwareLicence={removeSoftwareLicence}
                  setSoftwareLicenceQuantity={setSoftwareLicenceQuantity}
                  licenseLevel={licenseLevel}
                />
              </Fragment>
            );
          })}
        </Container>
      );
    }
  }

  export default LicenceGroup;
